import { http } from '@/http/axios.js';
export function getMsgTplListAPI() {
    return http({
        url: '/admin/wxcpMsgTpl/list',
        method: 'get'
    })
}
export function getMsgTplDetailAPI(id) {
    return http({
        url: '/admin/wxcpMsgTpl/detail',
        method: 'get',
        params: { id },
    })
}
export function editMsgTplStatusAPI(data) {
    return http({
        url: "/admin/wxcpMsgTpl/remindStatus/edit",
        method: "post",
        data,
    });
}
export function editMsgTplAPI(data) {
    return http({
        url: "/admin/wxcpMsgTpl/edit",
        method: "post",
        data,
    });
}
